import Header from "../Header";
import Footer from "../Footer";
import Breadcrumbs from "../Breadcrumbs";
import BannerImg from "../assets/Images/banner-1920x450.png";
import BottomLogoImg from "../assets/Images/bottom-logo.png";
import MainImg from "../assets/Images/agreement.png";
import TitleImg from "../assets/Images/title.png";
import LineImg from "../assets/Images/line.png";
import ImageTextLayout from "../shared/ImageTextLayout";
import "./ArbitrationAgreementPage.scss";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const ArbitrationAgreementPage = () => {
  const { t } = useTranslation();

  return (
    <>
      <Header />
      <div className="banner">
        <img src={BannerImg} alt="" />
        <div className="banner_title res">
          <h1 className="banner-main-title">{t("arbitration_agreement_page_header")}</h1>
          <p className="banner-subtitle">{t("arbitration_agreement_page_header2")}</p>
        </div>
      </div>
      <Breadcrumbs>
        <Link>{t("breadcrumbs_arbitration_agreement_page_link1")}</Link>
        <span>{t("breadcrumbs_arbitration_agreement_page_span")}</span>
        <Link>{t("breadcrumbs_arbitration_agreement_page_link2")}</Link>
      </Breadcrumbs>
      <ImageTextLayout
        image={MainImg}
        imageAlt="Arbitration agreement illustration"
        titleIcon={TitleImg}
        title={t("arbitration_agreement_page_h3")}
      >
        <p>{t("arbitration_agreement_page_text1")}</p>
        <p>{t("arbitration_agreement_page_text2")}</p>
        <p>{t("arbitration_agreement_page_text3")}</p>
        <p>{t("arbitration_agreement_page_text4")}</p>
        <p>{t("arbitration_agreement_page_text5")}</p>
        <p>{t("arbitration_agreement_page_text6")}</p>
        <p>{t("arbitration_agreement_page_text7")}</p>
      </ImageTextLayout>
      <div className="agreement-divider">
        <img src={LineImg} alt="Decorative line" className="divider-line" />
      </div>
      <div className="temporary">
        <img src={BottomLogoImg} alt="" className="bottom-logo" />
      </div>

      <Footer />
    </>
  );
};

export default ArbitrationAgreementPage;
